<template>
  <question-base-wrapper
    title="For how many days in a row is the property left empty?"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed, failedRules }"
      name="Property Unoccupied Days"
      :vid="`${stepId}_property-unoccupied-days`"
      :rules="{ is_not: { other: null } }"
      slim
    >
      <radio
        v-model.number="propertyUnoccupiedDaysModel"
        name="is-property-left-empty"
        wide
        column
        return-object
        :error="failed"
        :error-messages="getFieldErrors('propertyUnoccupiedDays', failedRules)"
        :items="propertyUnoccupiedDaysItems"
        :data-test="snakeCase(questionFields.propertyUnoccupiedDays)"
      />
    </validation-provider>

    <validation-provider
      v-if="isPropertyUnoccupiedDaysOther"
      id="content_propertyUnoccupiedDays-other"
      v-slot="{ errors, failed }"
      name="Property Unoccupied Days Other"
      :vid="`${stepId}_property-unoccupied-days`"
      rules="listOptionRequired"
      tag="div"
    >
      <qz-select
        v-model="questionData.propertyUnoccupiedDays"
        :items="propertyUnoccupiedDaysItemsOther"
        item-text="text"
        placeholder="Please select no. of days"
        :error="failed"
        :error-messages="errors"
        class="mt-4"
        :data-test="`${snakeCase(questionFields.propertyUnoccupiedDays)}_other`"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

import {
  pick,
  omit,
} from 'lodash';

export default {
  name: 'question-property-unoccupied-days',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyUnoccupiedDays'],
    };
  },

  computed: {
    propertyUnoccupiedDaysModel: {
      get () {
        if (this.questionData.propertyUnoccupiedDays === null) return null;
        return this.constants.HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE.includes(this.questionData.propertyUnoccupiedDays) ? this.questionData.propertyUnoccupiedDays : true;
      },
      set (val) {
        this.questionData.propertyUnoccupiedDays = val.logical ? val.logicalValue : val.value;
      },
    },

    isPropertyUnoccupiedDaysOther () {
      return !this.helpers.isNull(this.questionData.propertyUnoccupiedDays) && !this.constants.HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE.includes(parseInt(this.questionData.propertyUnoccupiedDays));
    },

    propertyUnoccupiedDaysItems () {
      return [...this.helpers.createOptions({ source: pick(this.constants.HOME_PROPERTY_UNOCCUPIED_DAYS, this.constants.HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE), asNumbers: true }), this.helpers.otherOption(false, 'More Than 14 Days in a Row')];
    },

    propertyUnoccupiedDaysItemsOther () {
      return this.helpers.createOptions({
        source: omit(
          this.constants.HOME_PROPERTY_UNOCCUPIED_DAYS,
          this.constants.HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE,
        ),
        asNumbers: true,
      });
    },
  },
};
</script>
